import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/auth";

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { initialized, loading, user } = useAuth();
  const loc = useLocation();

  if (!initialized || loading) {
    return <div className="p-4 text-sm text-muted-foreground">Checking session…</div>;
  }
  if (!user) {
    const redirect = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/auth/login?redirect=${redirect}`} replace />;
  }
  return <>{children}</>;
}

export default RequireAuth;
